import { IconButton, Tooltip, useColorScheme } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeIcon from '@mui/icons-material/DarkModeOutlined';

export function ThemeToggle() {
  const { mode, setMode } = useColorScheme();
  const next = mode === 'dark' ? 'light' : 'dark';
  return (
    <Tooltip title={next === 'dark' ? 'ໂໝດມືດ' : 'ໂໝດແຈ້ງ'}>
      <IconButton onClick={() => setMode(next)} color="inherit" aria-label="toggle color scheme">
        {mode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
      </IconButton>
    </Tooltip>
  );
}
